import template from './condition-type.jade';
import allItems, { itemsByCategory } from '../../../enums/condition-type';
import { filterItemsWithOrder } from '../../filter-items';

export default angular
    .module('cian.addForm.aboutObjectConditionType', [])
    .directive('cianAfAboutObjectConditionType', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'categoryService', function ($scope, categoryService) {
            $scope.$watch(() => this.ad.category, category => {
                if (!category) return;
                const { objectType } = categoryService.getInfoByCategory(category);

                if (itemsByCategory.hasOwnProperty(objectType)) {
                    const categoryConfig = itemsByCategory[objectType];
                    this.defaultValue = categoryConfig.defaultValue;
                    this.items = filterItemsWithOrder(allItems, 'value', categoryConfig.items);
                }
                else {
                    this.defaultValue = undefined;
                    this.items = [];
                }
            });
        }],
        controllerAs: 'conditionType',
        template,
    }))
    .name;
